"use client"

import { Divider } from '@mantine/core'
import { Facebook, Instagram, Twitter } from 'lucide-react'
import Link from 'next/link'
import StouxLogo from '../atoms/StouxLogo/StouxLogo'
import { useMediaQuery } from '@mantine/hooks'
import { useEffect, useState } from 'react'
import { IsMobile } from '@/utils/mobile'
import { getStore } from '@/utils/store'

export default function Footer() {
    
    const isMobile = IsMobile();
    const store = getStore();


    return (
        <footer className="flex flex-col gap-4 p-5 bg-[var(--primary)] items-center justify-center">
            {!store && (

                <div className="flex flex-col flex-1 items-center justify-center">
                <Link href="/" className="text-white">
                    <StouxLogo className="text-white" />
                </Link>
                <span className="text-xl font-semibold text-white text-center mt-2">
                    Rien ne se perd, rien ne se crée, tout se revend
                </span>
                <div className="flex flex-row gap-2 mt-2">
                    <Link
                        href="https://www.instagram.com/stouxfrance"
                        className="text-white bg-[var(--primary-dark)] flex flex-col items-center justify-center p-1 rounded-md w-[30px] h-[30px]"
                    >
                        <Instagram size={18} />
                    </Link>
                    <Link
                        href="https://www.facebook.com/profile.php?id=100089220213497"
                        className="text-white bg-[var(--primary-dark)] flex flex-col items-center justify-center p-1 rounded-md w-[30px] h-[30px]"
                    >
                        <Facebook size={18} />
                    </Link>
                    <Link
                        href="https://www.x.com/stouxfrance"
                        className="text-white bg-[var(--primary-dark)] flex flex-col items-center justify-center p-1 rounded-md w-[30px] h-[30px]"
                    >
                        <Twitter size={18} />
                    </Link>
                </div>
            </div>
            )}
              
            <div className="flex flex-row gap-4 text-center justfiy-between ">
                {!store && !isMobile && (
                    <>
                          <Link
                        href="/faq/vendre-sur-stoux"
                        className="text-white text-sm"
                    >
                        Vendre sur Stoux
                    </Link>
                     <Divider orientation="vertical" />
                    </>
              
                    )}
               
                <Link href={'/mentions-legales'} className="text-sm text-white">
                    Mentions légales
                </Link>
                <Link href={'/docs/cgv.pdf'} className="text-sm text-white">
                    CGV
                </Link>
                <Link href={'/support'} className="text-sm text-white">
                    Support
                </Link>
            </div>
           
        </footer>
    )
}
